import React, { useState } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import * as styles from './styles.module.scss'

import AnimatedNumber from '../AnimatedNumber'
import { animated, useSpring } from 'react-spring'
import InView from 'react-intersection-observer'

const PackagesDistance: React.FC = () => {
	const { t } = useTranslation()
	const [animatedPackages, setAnimatedPackages] = useState(false)
	const [animatedAnadyr, setAnimatedAnadyr] = useState(false)

	const packagesStyles = useSpring({
		transform: `translateX(${animatedPackages ? 0 : `200px`})`,
		opacity: animatedPackages ? 1 : 0,
		config: { mass: 1, tension: 400, friction: 80 },
		delay: 1000
	})

	const anadyrStyles = useSpring({
		transform: `translateX(${animatedAnadyr ? 0 : `-200px`})`,
		opacity: animatedAnadyr ? 1 : 0,
		config: { mass: 1, tension: 400, friction: 80 },
		delay: 1000
	})

	return (
		<>
			<section className="position-relative mt-8">
				<div className={`${styles.asideBg} ${styles.asideBgLeft}`} />
				<div className="container position-relative">
					<div className={styles.darkoveBaleni}>
						<img
							src="/2021/images/darkove-baleni.png"
							alt=""
							className={`${styles.img} ${styles.darkoveBaleniImg}`}
						/>
						<animated.h4 className="h2" style={packagesStyles}>
							{t('packagesDistance.packages.title')}
						</animated.h4>
						<strong className="display-2 text-primary">
							<AnimatedNumber number={359000} />
						</strong>
						<InView
							onChange={(inView) => inView && setAnimatedPackages(true)}
						/>
					</div>
				</div>
			</section>
			<section className={`${styles.anadyrSection} position-relative mb-8`}>
				<div className={`${styles.asideBg} ${styles.asideBgRight}`} />
				<div className="container position-relative text-end">
					<div className={styles.petrohrad}>
						<div className={`${styles.img} ${styles.petrohradImg}`}>
							<div className={styles.petrohradInner}>
								<img
									src="/2021/images/anadyr.png"
									className={styles.petrohradFront}
								/>
								<img
									src="/2021/images/anadyr_back.png?v=1"
									className={styles.petrohradBack}
								/>
							</div>
						</div>
						<animated.h4 className="h2" style={anadyrStyles}>
							{t('packagesDistance.distance.title')}
						</animated.h4>
						<strong className="display-2 text-primary">
							{t('packagesDistance.distance.where')}
						</strong>
						<InView onChange={(inView) => inView && setAnimatedAnadyr(true)} />
						<span className={`h4 ${styles.petrohradNote}`}>
							{t('packagesDistance.distance.note')}
						</span>
					</div>
				</div>
			</section>
		</>
	)
}

export default PackagesDistance
